/* DEADWEIGHT — theme.js v2.0 */
(function () {
  'use strict';

  /* ---------- HEADER SCROLL STATE ---------- */
  const header = document.getElementById('SiteHeader');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- MOBILE MENU ---------- */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.getElementById('MobileMenu');
  const overlay    = document.querySelector('[data-overlay]');

  function openMenu() {
    mobileMenu && mobileMenu.classList.add('is-open');
    overlay    && overlay.classList.add('is-active');
    menuToggle && menuToggle.classList.add('is-active');
    menuToggle && menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileMenu && mobileMenu.classList.remove('is-open');
    overlay    && overlay.classList.remove('is-active');
    menuToggle && menuToggle.classList.remove('is-active');
    menuToggle && menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  menuToggle && menuToggle.addEventListener('click', () => {
    menuToggle.classList.contains('is-active') ? closeMenu() : openMenu();
  });

  overlay && overlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeMenu();
  });

  /* ---------- FAQ ACCORDION ---------- */
  document.querySelectorAll('.faq-item__toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const item  = btn.closest('.faq-item');
      const isOpen = item.classList.contains('is-open');
      // Close all
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('is-open'));
      // Toggle clicked
      if (!isOpen) item.classList.add('is-open');
    });
  });

  /* ---------- VARIANT PILLS ---------- */
  document.querySelectorAll('.product-form__variants').forEach(group => {
    group.querySelectorAll('.variant-pill').forEach(pill => {
      pill.addEventListener('click', () => {
        if (pill.disabled) return;
        group.querySelectorAll('.variant-pill').forEach(p => p.classList.remove('is-active'));
        pill.classList.add('is-active');
      });
    });
  });

  /* ---------- QUANTITY STEPPER ---------- */
  document.querySelectorAll('.product-form__qty').forEach(wrap => {
    const input = wrap.querySelector('.product-form__qty-input');
    wrap.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      const v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
    });
    wrap.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      const v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  });

  /* ---------- PRODUCT MEDIA THUMBNAILS ---------- */
  document.querySelectorAll('.product__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src   = thumb.querySelector('img')?.src;
      const main  = thumb.closest('.product__media-stack')?.querySelector('.product__media img');
      if (src && main) {
        main.src = src;
        thumb.closest('.product__media-thumbs')?.querySelectorAll('.product__thumb').forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      }
    });
  });

  /* ---------- SCROLL REVEAL ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
  } else {
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('is-visible'));
  }

  /* ---------- CART COUNT SYNC ---------- */
  async function refreshCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      const badge = document.querySelector('.cart-badge');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    } catch (_) {}
  }

  /* Refresh count after add-to-cart forms submit */
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', () => {
      setTimeout(refreshCartCount, 500);
    });
  });

  /* ---------- ANNOUNCEMENT PAUSE ON HOVER ---------- */
  const annTrack = document.querySelector('.announcement-inner');
  if (annTrack) {
    annTrack.addEventListener('mouseenter', () => annTrack.style.animationPlayState = 'paused');
    annTrack.addEventListener('mouseleave', () => annTrack.style.animationPlayState = 'running');
  }

})();
